var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TarjetaDatos',{attrs:{"titulo":"Asegurados"}},_vm._l((_vm.asegurados),function(ase){return _c('div',{key:ase.numDoc},[_c('Campo2L',{attrs:{"valor":ase.nombreCompleto}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }